import { GridAction } from '@eforall/dashboard';
import { AcceleratorCourseFeedback } from '../accelerator-course-feedback-view.part';

export function getActions() {

	const actions: GridAction<AcceleratorCourseFeedback>[] = [];

	return actions;
}